export default __webpack_public_path__ + "0d4ec98c16790cfa0f7e9f264b273594.svg";